import React from 'react';
import { linkifyText } from 'utils/linkifyText';

type CitationListProps = {
  citations?: string[];
  usedIndices?: number[];
  className?: string;
};

const dedupeIndices = (indices: number[]): number[] => {
  const seen = new Set<number>();
  const unique: number[] = [];
  indices.forEach((index) => {
    if (!Number.isFinite(index) || index < 1) {
      return;
    }
    if (!seen.has(index)) {
      seen.add(index);
      unique.push(index);
    }
  });
  return unique.sort((a, b) => a - b);
};

export const CitationList: React.FC<CitationListProps> = ({
  citations,
  usedIndices,
  className,
}) => {
  const normalized = (citations ?? []).map((entry) =>
    typeof entry === 'string' ? entry.trim() : '',
  );
  const fallbackIndices = normalized.map((_, index) => index + 1);
  const rawIndices = usedIndices && usedIndices.length > 0 ? usedIndices : fallbackIndices;
  const indicesToRender = dedupeIndices(rawIndices).filter(
    (index) => index >= 1 && index <= normalized.length && normalized[index - 1].length > 0,
  );

  if (indicesToRender.length === 0) {
    return null;
  }

  return (
    <div className={['px-10 pb-6 text-left', className].filter(Boolean).join(' ')}>
      <div className="mt-2 border-t border-border/40 pt-4">
        <ol className="ml-4 list-decimal space-y-2 text-sm text-muted-foreground">
          {indicesToRender.map((index) => (
            <li key={`citation-${index}`} value={index} className="leading-relaxed">
              {linkifyText(normalized[index - 1])}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
